import { defineFilters, enumOne, enumOrAny, flag, text, type FilterOption } from '@/components/kit/filters'
import type { CatalogueSortField, CatalogueSourceFilter, CatalogueStockFilter } from '@/types/catalogue'

import { GAME_OPTIONS } from './card-constants'

export const CATALOGUE_SOURCE_OPTIONS: FilterOption<CatalogueSourceFilter>[] = [
    { value: 'all', label: 'Packs & cases' },
    { value: 'pack', label: 'Packs only' },
    { value: 'case', label: 'Cases only' }
]

export const CATALOGUE_STOCK_OPTIONS: FilterOption<CatalogueStockFilter>[] = [
    { value: 'all', label: 'Any stock' },
    { value: 'in', label: 'In stock', hint: 'At least one unit available' },
    { value: 'out', label: 'Out of stock', hint: 'Nothing available to ship' }
]

export const CATALOGUE_SORT_OPTIONS: FilterOption<CatalogueSortField>[] = [
    { value: 'name', label: 'Name' },
    { value: 'set', label: 'Set' },
    { value: 'price', label: 'Price' },
    { value: 'available', label: 'Available' },
    { value: 'reserved', label: 'Reserved' },
    { value: 'shipped', label: 'Shipped' }
]

const ORDER_OPTIONS: FilterOption<'asc' | 'desc'>[] = [
    { value: 'asc', label: 'Ascending' },
    { value: 'desc', label: 'Descending' }
]

/**
 * Catalogue filters, now in the URL. The legacy page kept all of this in component
 * state, so the `slug` drill-down -- the one filter you reach by clicking a badge and
 * would most want to send to someone -- could not be shared or restored.
 */
export const catalogueFilters = defineFilters(
    {
        search: text({ label: 'Search' }),
        game: enumOrAny(GAME_OPTIONS, { label: 'Game' }),
        source: enumOne(CATALOGUE_SOURCE_OPTIONS, 'all', { label: 'Source' }),
        stock: enumOne(CATALOGUE_STOCK_OPTIONS, 'all', { label: 'Stock' }),
        /** Set by clicking a pack or case badge in the Appears in column. */
        slug: text({ label: 'Product' }),
        includeHidden: flag({ label: 'Hidden products' }),
        sortBy: enumOne(CATALOGUE_SORT_OPTIONS, 'name', { label: 'Sort' }),
        sortOrder: enumOne(ORDER_OPTIONS, 'asc', { label: 'Order' })
    },
    { defaultLimit: 25, maxLimit: 500 }
)

export type CatalogueSearch = ReturnType<typeof catalogueFilters.parse>
